<template>
    <div class="cover-candidate">
        <el-dialog title="AI封面功能 is coming!" v-bind="$attrs" @close="closeDialog" append-to-body width="800px">
            <div class="cover-candidate-image">
                <p>AI 自动制作专辑封面正在测试中， 加入<el-button type="text" class="underline"
                        @click="closeDialog(); dialogVisible = true;">加入等待名单</el-button>，尝鲜功能 </p>
                <div class="image">
                    <div class="item">
                        <img src="@/assets/img/ai/img-1.png" />
                    </div>
                    <div class="item">
                        <img src="@/assets/img/ai/img-2.png" />
                    </div>
                    <div class="item">
                        <img src="@/assets/img/ai/img-3.png" />
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="info" @click="closeDialog">我知道</el-button>
            </span>
        </el-dialog>
        <el-dialog title="登记名单" :visible.sync="dialogVisible" append-to-body width="600px">
            <div class="cover-candidate-image">
                <p>登记后，可能会有工程师联系您。您的下一张专辑预计发布时间？</p>
                <div class="form-inline"
                    style="margin-top: 40px;display: flex;justify-content: space-between;align-items: center;">
                    <label style="width: 200px;">预计发布时间</label>
                    <el-date-picker style="width: 100%;" :picker-options="pickerOptions" v-model="estimatedProductTime"
                        type="datetime" value-format="timestamp" placeholder="选择日期时间">
                    </el-date-picker>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="info" @click="dialogVisible = false">放弃，下次再等待</el-button>
                <el-button type="primary" @click="registerWhitelist">提交等待需求</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { aiCoverWishlist } from '@/api/ai';
export default {
    inheritAttrs: false,
    data() {
        return {
            dialogVisible: false,
            loading: false,
            estimatedProductTime: null,
            pickerOptions: {
                disabledDate: (time) => time.getTime() < new Date().getTime()
            },
        };
    },
    created() { },
    methods: {
        closeDialog() {
            this.$emit('update:visible', false);
        },
        async registerWhitelist() {
            const { estimatedProductTime } = this;
            if (!estimatedProductTime) return this.$message.error('请选择您下张专辑的发布时间。');
            this.loading = true;
            const aiResponse = await aiCoverWishlist(estimatedProductTime)
            const { state, msg } = aiResponse.data;
            this.loading = true;
            if (!state) return this.$message.error(msg || '许愿失败，稍后尝试～');
            this.$message.success('预约成功~');
            this.dialogVisible = false;
        }
    }
};
</script>
<style lang="scss" scoped>
.cover-candidate-image {
    text-align: center;

    .image {
        display: flex;
        justify-content: space-between;
        margin-top: 40px;

        .item {
            width: 200px;
            height: 200px;

            img {
                width: 100%;
            }
        }
    }
}
</style>